export const TYPES = ['label', 'text-label'];

export const VARIANTS = ['info', 'success', 'neutral', 'ai-gradient', 'ai-gradient-light', 'tru', 'lime'];

export const LAYOUTS = ['solid', 'subtle'];

export const SIZES = ['xl', 'l', 's'];

export const THEMES = ['light', 'dark'];

export default {};
